import {Injectable, Optional} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot} from '@angular/router';
import {AcabimAuthService} from '@cas-hub/acabim-common-client';
import {NGXLogger} from 'ngx-logger';

@Injectable({
    providedIn: 'root'
})
export class AdminAuthGuardService implements CanActivate {

    constructor(private readonly authorize: AcabimAuthService,
                @Optional() private readonly logger?: NGXLogger) { }

    public async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        const user = await this.authorize.getUser().toPromise();
        if (!user) {
            return false;
        }

        const isAdmin = user.isAdmin;
        if (!isAdmin) {
            this.logger?.error('[AdminAuthGuardService] User has no sufficient access rights to admin space');
        }

        return isAdmin;
    }
}
